import { z } from 'zod';
import { IconSpec } from './IconSpec';
export var ModuleSpec = z.object({
    name: z.string().nonempty(),
    subtitle: z.string().optional(),
    description: z.string().optional(),
    enabled: z.boolean().optional().default(true),
    hidden: z.boolean().optional().default(false),
});
export var GroupSpec = z.object({
    name: z.string().nonempty(),
    icon: IconSpec.optional(),
    description: z.string().optional(),
    expanded: z.boolean().optional(),
});
export var InputSpec = z
    .object({
    type: z.enum([
        'boolean',
        'number',
        'stringlist',
        'enumlist',
        'style',
        'text',
    ]),
    label: z.string().nonempty(),
    group: z.string().optional(),
})
    .catchall(z.any());
export var ThemeSpec = z.object({
    name: z.string().nonempty(),
    subtitle: z.string().optional(),
    description: z.string().optional(),
    config: z
        .object({
        enabledModules: z
            .record(z.string(), z.boolean())
            .optional()
            .default({}),
        inputConfigs: z.record(z.string(), z.any()).optional().default({}),
    })
        .optional(),
});
export var SiteMetadataSpec = z.object({
    version: z.literal(1).optional(),
    source: z.string().url().optional(),
    commit: z
        .string()
        .regex(/^[a-f0-9]{40}$/i)
        .optional(),
    revisionUrl: z.string().url().optional(),
    sourceHash: z
        .string()
        .regex(/^[a-f0-9]{40}$/i)
        .optional(),
    config: z.record(z.string(), z.any()).optional(),
    name: z.string().optional(),
    description: z.string().optional(),
});
